import { Tag } from '../../ui-components/tag/tag';
import { useAppContext } from '../../app-context-provider/app-context-provider';
import { TranslationKeys } from '../../../i18n/translations';

const POST_TYPE_KEYS: Record<string, TranslationKeys> = {
    page: TranslationKeys['post-type-page'],
    news: TranslationKeys['post-type-news'],
    blog: TranslationKeys['post-type-blog'],
    project: TranslationKeys['post-type-project'],
    client: TranslationKeys['post-type-client'],
};

export const postTypeTranslationKey = (type: string): TranslationKeys | null =>
    POST_TYPE_KEYS[type] ?? null;

export const SearchResult = (props: SearchResultProps) => {
    const { translate } = useAppContext();
    const key = postTypeTranslationKey(props.postType);
    return (
        <a
            class="active:bg-accent1-100 hover:bg-accent1-100 rounded-m animate-fade-in-move-up flex flex-col space-y-3 p-3 transition-colors duration-300 ease-in-out"
            href={props.href}
        >
            <p class="text-headerS font-bold">{props.postTitle}</p>
            <p class="text-paragraphS line-clamp-2 text-neutral-600">{props.postContent}</p>
            <Tag text={key ? translate(key) : props.postType} />
        </a>
    );
};

type SearchResultProps = {
    href: string;
    postTitle: string;
    postType: string;
    postContent: string;
};
